document.addEventListener('DOMContentLoaded', () => {
  if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const variant = event.data.variant;
    const note = document.getElementById(`Backorder-${event.data.sectionId}`);
    if (!note) return;

    const isBackorder =
      variant &&
      variant.inventory_management &&
      variant.inventory_quantity <= 0 &&
      variant.inventory_policy === 'continue';

    note.hidden = !isBackorder;
  });
});